<template>
  <div class="defect-table">
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :columns="tableColumns"
      size="small"
      resizable
      border
      show-footer
      :footer-method="footerMethod"
      height="350"
    >
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('tips_no_data') || '暂无数据' }}</p>
        </div>
      </template>

      <template v-slot:subtract="{ row, rowIndex }">
        <el-button
          v-if="!disabled"
          type="text"
          icon="el-icon-remove-outline"
          circle
          style="color: #f56c6c;font-size: 16px;"
          @click="handleSubtract(row, rowIndex)"
        />
      </template>

      <template v-slot:operation="{ row, rowIndex }">
        <el-button
          v-if="!disabled"
          type="text"
          size="small"
          style="color: #f56c6c"
          @click="handleDelete(row, rowIndex)"
        >
          {{ $l('btn_delete') || '删除' }}
        </el-button>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  name: 'DefectTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          type: 'seq',
          title: this.$l('table_label_index') || '#',
          width: 60,
          align: 'center'
        },
        {
          field: 'defectIssuesTitle',
          title: this.$l('table_label_defect_issue') || '疵点',
          align: 'center',
          minWidth: 200
        },
        {
          field: 'quantity',
          title: this.$l('table_label_quantity') || '数量',
          width: 120,
          align: 'center'
        },
        {
          field: 'subtract',
          title: this.$l('table_label_defect_quantity') || '减数量',
          width: 100,
          align: 'center',
          slots: { default: 'subtract' }
        },
        {
          field: 'operation',
          title: this.$l('table_label_operation') || '操作',
          width: 100,
          align: 'center',
          slots: { default: 'operation' }
        }
      ]
    }
  },
  methods: {
    handleDelete(row, index) {
      this.$emit('delete', { row, index })
    },
    handleSubtract(row, index) {
      this.$emit('subQuantity', { row, index })
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return ''
          }
          if (columnIndex === 1) {
            return this.$l('table_label_total') || '合计'
          }

          // 数量合计
          if (column.property === 'quantity') {
            const total = data.reduce((sum, row) => {
              const qty = parseFloat(row.quantity) || 0
              return sum + qty
            }, 0)
            return total
          }

          return null
        })
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.defect-table {
  width: 50%;
  .no-data {
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
  }
}

::v-deep {
  .vxe-table--footer {
    .vxe-footer--row {
      background-color: #f5f7fa;
      font-weight: 600;
      .vxe-footer--column {
        &:first-child {
          text-align: center;
        }
      }
    }
  }
}
</style>
